export default __webpack_public_path__ + "static/media/Keep Trying.b168a34a.png";